import React from "react";
import { ShoppingBag, Car, Utensils, Pill, Wrench, Factory, Package, FlaskConical } from "lucide-react";

const IND = [
  { icon: ShoppingBag, title: "Retail & CPG", desc: "Store replenishment, DC-to-DC, and peak season capacity." },
  { icon: Car, title: "Automotive", desc: "Just-in-sequence parts, tier-one plant support, expedited critical parts." },
  { icon: Utensils, title: "Food & Beverage", desc: "FSMA-compliant reefer, produce lanes, and cold chain continuity." },
  { icon: Pill, title: "Pharma & Cold Chain", desc: "Validated temperature control, chain-of-custody, and GxP handling." },
  { icon: Wrench, title: "Building Materials", desc: "Flatbed, step-deck, and heavy-haul across builder and distributor networks." },
  { icon: Factory, title: "Manufacturing", desc: "Inbound raw materials and outbound finished goods for plant floors." },
  { icon: Package, title: "E-Commerce", desc: "Middle-mile and final-mile solutions for D2C and marketplace brands." },
  { icon: FlaskConical, title: "Chemicals", desc: "Hazmat-certified equipment, drivers, and dedicated safety protocols." },
];

export default function Industries() {
  return (
    <div>
      <section className="bg-[#0B3D6E] text-white py-20">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="font-label text-xs text-[#2E7BC7]">Industries</div>
          <h1 className="mt-3 font-display font-black text-4xl md:text-6xl max-w-3xl">Specialized freight for the industries that matter.</h1>
        </div>
      </section>
      <section className="py-16 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 grid md:grid-cols-2 lg:grid-cols-4 gap-5">
          {IND.map(({ icon: Icon, title, desc }, i) => (
            <div key={title} className="border border-gray-200 rounded-lg p-6 hover:-translate-y-1 hover:border-[#2E7BC7]/40 transition-all" data-testid={`industry-${i}`}>
              <Icon className="h-8 w-8 text-[#2E7BC7]" />
              <div className="mt-4 font-display font-bold text-lg text-[#0B3D6E]">{title}</div>
              <p className="mt-2 text-sm text-slate-600">{desc}</p>
            </div>
          ))}
        </div>
      </section>
    </div>
  );
}
